/*
  Module: app-config
 */

var config = {
  mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
  breakpoints: {
    tiny: 480,
    small: 974,
    medium: 1068,
    large: 1200,
    xlarge: 1650
  },
  helpers: {
    getEms: function(value) {
      return parseInt(value, 10) / parseFloat(window.getComputedStyle(document.body, null).getPropertyValue('font-size'));
    },

    /**
     * Check if element if in of viewport
     * @source: http://stackoverflow.com/a/23234031/3029319
     * @param  {Object}  el
     * @return {Boolean}
     */
    isElementInViewport: function(el, offsetTop, offsetLeft) {
      var rect = el.getBoundingClientRect();

      offsetTop = offsetTop || 0;
      offsetLeft = offsetLeft || 0;

      return !(rect.bottom < 0 + offsetTop || rect.right < 0 + offsetLeft || rect.left > window.innerWidth + offsetLeft || rect.top > window.innerHeight + offsetTop);
    },

    /**
     * Get highest element from element's children
     * @param  {jQuery} el    parent element
     * @param  {jQuery} child child element
     * @return {Number}       return height
     */
    getHighestElement: function(el, child) {
      var heights = [];
      el.find(child).each(function() {
        heights.push($(this).height());
      });
      return Math.max.apply(null, heights);
    },

    /**
     * Get prefixed transition end
     * @return {String} returns prefixed property
     */
    getPrefixedTransitionEnd: function() {
      var prefixes = {
        'transition': 'transitionend',
        'OTransition': 'otransitionend',
        'MozTransition': 'transitionend',
        'WebkitTransition': 'webkitTransitionEnd'
      };

      return prefixes[Modernizr.prefixed('transition')];
    },

    isGoogleMapLoaded: false

  }
};

config.resizeEvent = (config.mobile) ? 'orientationchange': 'resize';

module.exports = config;



// WEBPACK FOOTER //
// ./src/_app/app-config.js